<nwm-menu #menu />

<div class="content content-white-section" [ngClass]="{prelogin:!menu.user}">
  <div class="flex-margin"></div>
  <router-outlet />
</div>